import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Header from '../components/header'
import Footer from '../components/footer'

import './fonts'
import 'normalize.css'
import 'flexboxgrid'
import './index.scss'

const Layout = ({ children, data }) => (
  <div className="container">
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        {
          name: 'description',
          content: 'Shareholding Disclosure data is important information for all market participants'
        },
      ]}
    />
    <Header />
    <div className="row">
      <div className="col-sm-offset-4 col-sm-8 col-xs-offset-1 col-xs-10">
        {children()}
      </div>
    </div>
    <Footer copyright="2018 Share Disclosure Limited" />
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js